import React from 'react';
import '../anima/Splash/src/screens/CcSplash/style.css';
import '../anima/Splash/styleguide.css';
import { CcSplash } from '../anima/Splash/src/screens/CcSplash';

/**
 * Local-only preview page for the splash/loading screen.
 * This route is conditionally registered on localhost in App.tsx.
 */
const SplashPreview: React.FC = () => {
  return (
    <div style={{ position: 'fixed', inset: 0 }}>
      <CcSplash progress={65} />
    </div>
  );
};

export default SplashPreview;


